import log from 'salvo-lite/log'

class PaymentMethods {
    constructor (theme, elem) {
        this._name = this.constructor.name
        this._theme = theme
        this._elem = elem
        this._data = JSON.parse(elem.dataset.paymentMethods)
        this._elems = {
            'addTo': document.querySelectorAll(this._data.addTo),
            'paymentMethods': []
        }
    }

    onInit () {
        log.debug(this._name, 'Fired', this)
        this._addPaymentMethods()
    }

    _addPaymentMethods () {
        for (let imgUrl of this._data.images) this._elems.paymentMethods.push(this._generatePaymentMethod(imgUrl))
        for (let elem of this._elems.paymentMethods) this._addPaymentMethod(elem)
    }

    _addPaymentMethod (newElem) {
        log.debug(this._name, 'Adding Payment Method', newElem)
        for (let elem of this._elems.addTo) {
            log.debug(this._name, 'Container', elem)
            elem.insertBefore(newElem.cloneNode(false), elem.childNodes[0])
        }
    }

    _generatePaymentMethod (imgUrl) {
        let newSpan = document.createElement('span')
        newSpan.classList.add('custom-payment-icon', 'payment-icon')
        newSpan.style.backgroundImage = `url(${imgUrl})`
        return newSpan
    }
}

export default PaymentMethods



// WEBPACK FOOTER //
// ./src/scripts/components/PaymentMethods.js